const init = () => {
  const webApiBaseUrl = import.meta.env.VITE_WEB_API_BASE_URL;
  const cognitoBaseUrl = import.meta.env.VITE_COGNITO_BASE_URL;
  const cognitoClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  const userPoolId = import.meta.env.VITE_COGNITO_USERPOOL_ID;
  const applicationBaseUrl = import.meta.env.VITE_APPLICATION_BASE_URL;
  const applicationName = import.meta.env.VITE_APPLICATION_NAME || "";

  const ddApplicationId = import.meta.env.VITE_DD_APPLICATION_ID;
  const ddClientToken = import.meta.env.VITE_DD_CLIENT_TOKEN;
  const ddEnv = import.meta.env.VITE_DD_ENVIRONMENT;
  const ddServiceName = import.meta.env.VITE_DD_SERVICE_NAME;

  if (!webApiBaseUrl) {
    throw new Error(
      "missing required environment variable: [VITE_WEB_API_BASE_URL]"
    );
  }
  if (!cognitoBaseUrl) {
    throw new Error(
      "missing required environment variable: [VITE_COGNITO_BASE_URL]"
    );
  }
  if (!cognitoClientId) {
    throw new Error(
      "missing required environment variable: [VITE_COGNITO_CLIENT_ID]"
    );
  }
  if (!userPoolId) {
    throw new Error(
      "missing required environment variable: [VITE_COGNITO_USERPOOL_ID]"
    );
  }

  if (!ddApplicationId) {
    throw new Error(
      "missing required environment variable: [VITE_DD_APPLICATION_ID]"
    );
  }
  if (!ddClientToken) {
    throw new Error(
      "missing required environment variable: [VITE_DD_CLIENT_TOKEN]"
    );
  }
  if (!ddEnv) {
    throw new Error(
      "missing required environment variable: [VITE_DD_ENVIRONMENT]"
    );
  }
  if (!ddServiceName) {
    throw new Error(
      "missing required environment variable: [VITE_DD_SERVICE_NAME]"
    );
  }

  const graphApiConfig = {
    tenantId: import.meta.env.VITE_GRAPH_TENANT_ID,
    clientId: import.meta.env.VITE_GRAPH_CLIENT_ID,
    redirectUri: import.meta.env.VITE_GRAPH_REDIRECT_URI,
    chatIds: {
      ammonia: import.meta.env.VITE_AMMONIA,
      ats: import.meta.env.VITE_ATS,
      phosphate: import.meta.env.VITE_PHOSPHATE,
      superu: import.meta.env.VITE_SUPERU,
      uan: import.meta.env.VITE_UAN,
      urea: import.meta.env.VITE_UREA,
    },
  };

  if (!graphApiConfig.tenantId) {
    throw new Error(
      "missing required environment variable: [VITE_GRAPH_TENANT_ID]"
    );
  }
  if (!graphApiConfig.tenantId) {
    throw new Error(
      "missing required environment variable: [VITE_GRAPH_CLIENT_ID]"
    );
  }
  if (!graphApiConfig.tenantId) {
    throw new Error(
      "missing required environment variable: [VITE_GRAPH_REDIRECT_URI]"
    );
  }
  if (!graphApiConfig.chatIds.uan) {
    throw new Error("missing required environment variable: [VITE_UAN]");
  }
  if (!graphApiConfig.chatIds.urea) {
    throw new Error("missing required environment variable: [VITE_UREA]");
  }
  if (!graphApiConfig.chatIds.ammonia) {
    throw new Error("missing required environment variable: [VITE_AMMONIA]");
  }
  if (!graphApiConfig.chatIds.superu) {
    throw new Error("missing required environment variable: [VITE_SUPERU]");
  }
  if (!graphApiConfig.chatIds.phosphate) {
    throw new Error("missing required environment variable: [VITE_PHOSPHATE]");
  }
  if (!graphApiConfig.chatIds.ats) {
    throw new Error("missing required environment variable: [VITE_ATS]");
  }

  return {
    webApiBaseUrl,
    cognitoBaseUrl,
    cognitoClientId,
    applicationBaseUrl,
    applicationName,
    userPoolId,
    ddApplicationId,
    ddClientToken,
    ddEnv,
    ddServiceName,
    graphApiConfig,
  };
};

export const env = init();
